module.exports = __webpack_public_path__ + "static/9.9efd446d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MasterTheses/9.png
// module id = 831
// module chunks = 39236203315009 172526442442348